import { FunctionComponent } from 'react';
import styles from './CustomEvaluationQuestion.module.scss';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import { Radio } from 'components/UI/V3/Forms/Radio/Radio';

export interface CustomEvaluationQuestionProps {
    questionText: string;
    questionId: number;
    selectedAnswer?: string;
    onChange: (questionId: number, answer: string) => void;
}

const OPTIONS = ['pass', 'fail', 'conditional_pass'];

const LABELS: Record<string, string> = {
    pass: 'Pass',
    fail: 'Fail',
    conditional_pass: 'Conditional Pass'
};

export const CustomEvaluationQuestion: FunctionComponent<CustomEvaluationQuestionProps> = ({
    questionText,
    questionId,
    selectedAnswer,
    onChange
}) => {
    return (
        <div className={styles.responseSection}>
            <Label className={styles.responseLabel}>{questionText}</Label>
            <div className={styles.radioGroup}>
                {OPTIONS.map(option => (
                    <Radio
                        key={option}
                        inlineLabel={LABELS[option]}
                        checked={selectedAnswer === option}
                        onChange={() => onChange(questionId, option)}
                        className={styles.radioOption}
                    />
                ))}
            </div>
        </div>
    );
};
